export const OFFLINE_MUTATION_CODE = 'ERR_OFFLINE_MUTATION';
